<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r.HSN_CODE + '  ' + r.DDC_CODE + '  - ' + r.TRADE_NAME" [term]="t"></ngb-highlight>
</ng-template>

<app-page-header [heading]="' Purchase Return'" [icon]="'fa-undo'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class="row">
    <div class="form-group col-lg-4">
      <label>Supplier Name</label><span class="text-danger">&nbsp;*</span>
      <ngx-select-dropdown (change)="getVendor();" [(ngModel)]="vendor_data"
                           [config]="utils.dropConfig({displayKey: 'VENDOR_NAME',placeholder: 'Select Supplier',searchOnKey: 'VENDOR_NAME'})"
                           [multiple]="false"
                           [options]="vendor_options" class="form-control  select-dropdown"
                           name="sel_tpa_receiver"></ngx-select-dropdown>

    </div>
    <div class="form-group col-lg-4">
      <label for="Date">Reference Number</label><span class="text-danger">&nbsp;*</span>
      <input [(ngModel)]="purchase_retrun.reference_no" class="form-control " name="invoice" type="text">
    </div>
    <div class="form-group col-lg-4">
      <label for="Date">Return Date</label><span class="text-danger">&nbsp;*</span>
      <input (ngModelChange)="purchase_retrun.return_date = $event" [max]="getToday()"
             [ngModel]="purchase_retrun.return_date | date:'yyyy-MM-dd' "
             class="form-control " id="date" min="{{invoiceDate()|date:'yyyy-MM-dd'}}"
             name="date" type="date">
    </div>
  </div>
  <hr>
  <h5 class="list-header">Return Particular</h5>
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class="form-group">
    <table class="tbl table tbl-sm  table-bordered">
      <thead>
      <tr class="text-center">
        <th width="1%">#Sl</th>
        <th>Item<span class="text-danger">*</span></th>
        <th width="10%">Invoice No<span class="text-danger">&nbsp;*</span>
        </th>
        <th width="10%">UOM</th>
        <th width="10%"><span class="text-danger">&nbsp;*</span> Purchased Qty / Freebie Qty</th>
        <th width="10%"><span class="text-danger">&nbsp;*</span> Available Qty / Amount</th>
        <th width="8%"> VAT Amount</th>
        <th width="10%"> Actual Rate</th>
        <th width="10%"><span class="text-danger">&nbsp;*</span> Gross Amount / Unit Price <span class="text-danger">&nbsp;*</span>
        </th>
        <th width="10%"> Return Qty / Retrun Amount <span class="text-danger">&nbsp;*</span></th>
        <th width="1%">*</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let i of utils.buildArray(purchase_details.length)" id="{{ 'rowIndex' + i }}">
        <td class="text-center">{{ 1 + i }}</td>
        <td>
          <input (selectItem)="set_item_medicine($event,i)" [(ngModel)]="purchase_retrun.medicine_data[i]"
                 [class.is-invalid]="searchFailed" [inputFormatter]="formatter"
                 [ngModelOptions]="{standalone: true}" [ngbTypeahead]="medicine_search" [resultTemplate]="rt"
                 class="form-control" id="typeahead-http{{i}}"
                 placeholder="Search Particular Name...." style="height: 55px;"
                 type="text"/>
        </td>
        <td>
          <select (change)="listProductDetails(i);" [(ngModel)]="purchase_retrun.invoice_no[i]"
                  class="form-control  custom-select custom-select-sm ng-pristine ng-valid ng-touched"
                  name="invoice_no{{i}}"
                  style="margin-bottom: 2px">
            <option value="">Select</option>
            <option *ngFor="let data of invoice[i]" class="ng-tns-c13-1 ng-star-inserted"
                    value="{{data.INVOICE_NUMBER}}">{{ data.INVOICE_NUMBER }}
            </option>
          </select>
        </td>
        <td>
          <input [(ngModel)]="purchase_retrun.uom_arr_name[i]" [readOnly]="true" class="form-control  "
                 name="uom_arr_name{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input [(ngModel)]="purchase_retrun.purchased_qty[i]" [readOnly]="true" class="form-control  "
                 name="purchased_qty{{i}}" style="margin-bottom: 2px" tabindex="-1" type="text">

          <input [(ngModel)]="purchase_retrun.freebie_qty[i]" [readOnly]="true" class="form-control  "
                 name="uom_arr_name{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input [(ngModel)]="purchase_retrun.ava_quantity_arr[i]" [readOnly]="true"
                 class="form-control  "
                 name="quantity_arr{{i}}" style="margin-bottom: 2px" tabindex="-1" type="text">

          <input [(ngModel)]="purchase_retrun.amount_arr[i]" [readOnly]="true" class="form-control  "
                 name="amount_arr{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input [(ngModel)]="purchase_retrun.vat_arr[i]" [readOnly]="true" class="form-control  "
                 maxlength="7" name="vat_arr{{i}}" style="margin-bottom: 2px" tabindex="-1" type="text">
        </td>
        <td>
          <input [(ngModel)]="purchase_retrun.actual_arr[i]" [readOnly]="true" class="form-control  "
                 name="actaul_arr {{i}}" tabindex="-1" type="text">

        </td>
        <td>
          <input (focusout)="returnValue()" [(ngModel)]="purchase_retrun.gross_arr[i]" [readOnly]="true"
                 class="form-control  "
                 maxlength="7" name="gross_arr{{i}}" style="margin-bottom: 2px" tabindex="-1"
                 type="text">
          <input [(ngModel)]="purchase_retrun.unitprice_arr[i]" [readOnly]="true" class="form-control  "
                 maxlength="7"
                 name="unitprice_arr{{i}}" tabindex="-1" type="text">

        </td>
        <td class=" text-center">
          <input (focusout)="returnValue()" [(ngModel)]="purchase_retrun.return_qty_arr[i]"
                 class="form-control  "
                 maxlength="7" name="return_qty_arr{{i}}" style="margin-bottom: 2px" true
                 type="text">
          <input (focusout)="totalAmount()" [(ngModel)]="purchase_retrun.return_amount_arr[i]"
                 class="form-control  "
                 maxlength="7" name="return_amount_arr{{i}}" type="text">
        </td>
        <td>
          <button (click)="open(reason);pushReason(i)" alt="Return reason" class="btn btn-info btn-sm mb-1"><i
            class="fa fa-file-text "></i></button>
          <button (click)="deleterow(i)" *ngIf="purchase_details.length> 1" alt="Delete data"
                  class="btn btn-danger  btn-sm mb-1 "
                  title="Delete data" type="button"><i class="fa fa-trash"
                                                       style="color: white;"></i>

          </button>
          <button (click)="addrow(i)" *ngIf="i == purchase_details.length-1" alt="Add New data"
                  class="btn btn-success btn-sm "
                  title="Add New data" type="button"><i class="fa fa-plus"
                                                        style="color: white;"></i></button>


        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <td colspan="9" style="text-align: right"><label>Gross Total&nbsp;&nbsp;&nbsp;</label></td>
        <td style="text-align: right;width:10%"><label>{{ total_amount | number : '1.2-2' }}</label></td>
      </tr>
      </tfoot>
    </table>
    <div class="clearfix"></div>
  </div>
  <div class="clearfix"></div>
  <hr>
  <div class="clearfix"></div>

  <div class="row container">
    <div class="col-lg-7 pull-right">
      <button (click)="saveReturnPurchase()" *ngIf="user_rights.ADD == '1'"
              class="btn btn-info btn-sm ng-star-inserted"
              type="button">&nbsp;Save&nbsp;
      </button>
    </div>
  </div>
  <div style="height:100px"></div>

  <div class="clearfix"></div>
</div>
<ng-template #reason let-modal>
  <div class="modal-header">
    <div class="pull-right ">
      <h5 class="modal-title" id="modal-basic-title">
        Return Reason
      </h5>
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <textarea [(ngModel)]="purchase_retrun.return_reason[index]" class="form-control" name="return_reson"
              style="height: 168px; "></textarea>
    <div class="clearfix"></div>
    <button (click)="modal.dismiss('Cross click');pushReason(index)"
            class="btn-info  pull-right btn-sm ng-star-inserted">
      Save
    </button>
  </div>
</ng-template>
<ng-template let-modal>
  <div class="modal-header">
    <div class="pull-right ">
      <h5 class="modal-title" id="modal-basic-title">
        Purchase Details
      </h5>
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="clearfix"></div>
    <input [(ngModel)]="purchase_retrun.uom_arr_name[index]">
    <button (click)="modal.dismiss('Cross click');pushReason(index)"
            class="btn-info  pull-right btn-sm ng-star-inserted">
      Cancel
    </button>
  </div>
</ng-template>
